module.exports = __webpack_public_path__ + "video/SAF-1000_Ares_MobileDevicesAndRemoteSecurity_2025.0c23538d.vtt";